import { axiosInstance } from "../../../../config/api/Axios";

export const getQualityOfLifeApi = async (currentCityId, comparisonCityId) =>
    axiosInstance.get(`/intelligence/quality-of-life/${currentCityId}/${comparisonCityId}`);
